import { useChatContext } from "../ChatProvider";
import { Feedback } from "../types";
import { updateMessageFeedback } from "../store/chatSlice";

export const useFeedback = () => {
  const { dispatch, currentSessionId, urls, requestParams } = useChatContext();

  const submitFeedback = async (messageId: string, feedback: Feedback) => {
    try {
      // Make API call to submit feedback
      const feedbackPath = urls?.feedbackPath || "/agent/feedback";
      const feedbackUrl = urls?.origin ? `${urls.origin}${feedbackPath}` : feedbackPath;
      const response = await fetch(feedbackUrl, {
        method: "POST",
        headers: {
          ...(requestParams?.headers || {}),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          messageId: messageId.toString(),
          sessionId: currentSessionId,
          feedback,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit feedback");
      }

      // Update local state
      dispatch(
        updateMessageFeedback({
          messageId,
          feedback,
        })
      );
    } catch (error) {
      console.error("Failed to submit feedback:", error);
      throw error;
    }
  };

  return { submitFeedback };
};
